import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  IconButton,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ModeEditIcon from '@mui/icons-material/ModeEdit';

export default function BudgetListTable({
  budget,
  handleEditBudget,
  handleDeleteBudget,
  uiLang = 'en',
}) {
  const U = (th, en) => (uiLang === 'en' ? en : th);
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} size="small">
        <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
          <TableRow>
            <TableCell sx={{ fontWeight: 'bold' }}>{U('เลขงบประมาณ', 'Budget Number')}</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>{U('ชื่อ', 'Name')}</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }} align="right">
              {U('งบประมาณ', 'Cost')}
            </TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>{U('รายละเอียด', 'Description')}</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>{U('จัดการ', 'Actions')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {budget && Array.isArray(budget) && budget.length > 0 ? (
            budget.map((item, index) => (
              <TableRow
                key={item._id || index}
                sx={{
                  '&:hover': {
                    backgroundColor: '#fafafa',
                  },
                }}
              >
                <TableCell>{item.budget_number}</TableCell>
                <TableCell>{item.name}</TableCell>
                <TableCell align="right" sx={{ fontWeight: 500 }}>
                  {item.cost?.toLocaleString('th-TH', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </TableCell>
                <TableCell sx={{ color: '#666' }}>{item.description}</TableCell>
                <TableCell>
                  <IconButton
                    aria-label="edit"
                    size="small"
                    onClick={() => handleEditBudget(item)}
                  >
                    <ModeEditIcon fontSize="inherit" />
                  </IconButton>
                  <IconButton
                    aria-label="delete"
                    size="small"
                    onClick={() => handleDeleteBudget(item)}
                  >
                    <DeleteIcon fontSize="inherit" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell
                colSpan={5}
                align="center"
                sx={{ color: '#999', py: 3 }}
              >
                {U('ไม่มีข้อมูล', 'No data')}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
